import { setName } from "../../domain/subscribe/subscribeModel"
import { UpdateSubscribeStore, updateSubscribeUseCase } from "./updateSubscribeUseCase"


const setNameUseCase = (store: UpdateSubscribeStore, value: string) => 
    updateSubscribeUseCase(store, value, setName);


export { setNameUseCase }